export default __webpack_public_path__ + "static/center-de-062c348bcf47bcaf62ed89eadc7c99c4.webp";